document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.industries-section').forEach(section => {
        const track = section.querySelector('.industries-slider__track');
        if (!track) return;

        const cards = Array.from(track.querySelectorAll('.industry-card'));
        if (!cards.length) return;

        const prevBtn = section.querySelector('.slider-arrow--prev');
        const nextBtn = section.querySelector('.slider-arrow--next');

        if (cards.length <= 3) {
            if (prevBtn) prevBtn.style.display = 'none';
            if (nextBtn) nextBtn.style.display = 'none';
        }

        const MOBILE_BP    = 767;
        const AUTO_DELAY   = 3500;
        const DESKTOP_SPEED = 1.5;

        let rafId        = null;
        let autoTimer    = null;
        let currentIndex = 0;
        let isPaused     = false;
        let isDragging   = false;
        let mouseStartX  = 0;
        let mouseScrollL = 0;
        let touchStartX  = 0;
        let touchScrollL = 0;

        function cardWidth() {
            return cards[0].offsetWidth + 24; // 24px gap
        }

        function isMobile() {
            return window.innerWidth <= MOBILE_BP;
        }

        // ── Shared snap-based sliding ──────────────────────────────
        function snapTo(index) {
            const total = cards.length;
            currentIndex = ((index % total) + total) % total;
            track.scrollTo({ left: currentIndex * cardWidth(), behavior: 'smooth' });
        }

        function startAuto() {
            clearInterval(autoTimer);
            autoTimer = setInterval(() => {
                if (!isPaused && !isDragging) {
                    snapTo(currentIndex + 1);
                }
            }, AUTO_DELAY);
        }

        function stopAuto() {
            clearInterval(autoTimer);
            autoTimer = null;
        }

        // ── Arrows ────────────────────────────────────────────────
        function handlePrev() {
            stopAuto();
            snapTo(currentIndex - 1);
            startAuto();
        }

        function handleNext() {
            stopAuto();
            snapTo(currentIndex + 1);
            startAuto();
        }

        if (prevBtn) prevBtn.addEventListener('click', handlePrev);
        if (nextBtn) nextBtn.addEventListener('click', handleNext);

        // ── Mouse drag ──────────────────────────────────
        track.addEventListener('mouseenter', () => { isPaused = true; });
        track.addEventListener('mouseleave', () => {
            isDragging = false;
            isPaused = false;
            track.classList.remove('is-dragging');
        });
        track.addEventListener('mousedown', e => {
            isDragging = true;
            isPaused = true;
            mouseStartX = e.pageX - track.offsetLeft;
            mouseScrollL = track.scrollLeft;
            track.classList.add('is-dragging');
        });
        track.addEventListener('mouseup', () => {
            if (isDragging) {
                isDragging = false;
                track.classList.remove('is-dragging');
                const diff = mouseStartX - (event.pageX - track.offsetLeft);
                if (Math.abs(diff) > 40) {
                    snapTo(currentIndex + (diff > 0 ? 1 : -1));
                } else {
                    snapTo(currentIndex);
                }
            }
            isPaused = false;
        });
        track.addEventListener('mousemove', e => {
            if (!isDragging) return;
            e.preventDefault();
            track.scrollLeft = mouseScrollL - (e.pageX - track.offsetLeft - mouseStartX);
        });

        // ── Touch swipe ───────────────────────────────────────────
        track.addEventListener('touchstart', e => {
            touchStartX = e.touches[0].clientX;
            touchScrollL = track.scrollLeft;
            isPaused = true;
        }, { passive: true });

        track.addEventListener('touchmove', e => {
            // Optional: prevent default if you want strict horizontal swipe, 
            // but usually passive is true so we don't prevent default.
            track.scrollLeft = touchScrollL - (e.touches[0].clientX - touchStartX);
        }, { passive: true });

        track.addEventListener('touchend', e => {
            const diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 40) {
                snapTo(currentIndex + (diff > 0 ? 1 : -1));
            } else {
                snapTo(currentIndex);
            }
            isPaused = false;
        }, { passive: true });

        // ── Init / Resize ─────────────────────────────────────────
        function init() {
            stopAuto();
            currentIndex = Math.round(track.scrollLeft / cardWidth()) || 0;
            startAuto();
        }

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(init, 200);
        });

        init();
    });
});
